import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import splitStyles from '../system/split-styles';
import { spacingValue } from '../system';
import { joinChildren } from '../utils';
import { useVariant } from '../VariantProvider';
var BASELINE = 'baseline';
var CENTER = 'center';
var END = 'end';
var FILL = 'fill';
var HORIZONTAL = 'horizontal';
var SPACE_EVENLY = 'space-evenly';
var SPACE_BETWEEN = 'space-between';
var START = 'start';
var STRETCH = 'stretch';
var VERTICAL = 'vertical';
var stackViewPlugin = {
  styleProps: ['alignment', 'axis', 'distribution', 'spacing'],
  getStyles: function getStyles(_ref) {
    var inline = _ref.inline,
        alignment = _ref.alignment,
        axis = _ref.axis,
        distribution = _ref.distribution,
        spacing = _ref.spacing,
        styles = _objectWithoutPropertiesLoose(_ref, ["inline", "alignment", "axis", "distribution", "spacing"]);

    if (axis && styles.flexDirection === undefined) {
      styles.flexDirection = axis === HORIZONTAL ? 'row' : 'column';
    }

    if (alignment && styles.alignItems === undefined) {
      styles.alignItems = alignment;
    }

    if (distribution === FILL) {
      styles['& > *'] = {
        flex: '1 0 0px'
      };
    } else if (styles.justifyContent === undefined) {
      styles.justifyContent = distribution;
    }

    if (typeof spacing === 'number' || typeof spacing === 'string') {
      styles.gap = spacingValue(spacing);
    }

    return styles;
  }
};
var defaultElement = 'div';
export function StackView(_ref2) {
  var as = _ref2.as,
      children = _ref2.children,
      inline = _ref2.inline,
      innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "children", "inline", "innerRef"]);

  var Element = as || defaultElement;
  var variant = useVariant();
  var childrenToRender = Element === 'textarea' ? undefined : typeof props.spacing === 'object' ? joinChildren(children, props.spacing) : children;
  return jsx(Element, _extends({
    ref: innerRef
  }, splitStyles(_objectSpread({
    display: inline ? 'inline-flex' : 'flex',
    axis: VERTICAL,
    plugin: stackViewPlugin,
    variant: variant
  }, props))), childrenToRender);
}
StackView.BASELINE = BASELINE;
StackView.CENTER = CENTER;
StackView.END = END;
StackView.FILL = FILL;
StackView.HORIZONTAL = HORIZONTAL;
StackView.SPACE_BETWEEN = SPACE_BETWEEN;
StackView.SPACE_EVENLY = SPACE_EVENLY;
StackView.START = START;
StackView.STRETCH = STRETCH;
StackView.VERTICAL = VERTICAL;